// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__GPZSu","sendOtp":"AuthorizeToLogin_sendOtp__DwpTR"};